import {css} from '../../theme/css'

export const classes = {
  noMobilePressEffects: css`
    -webkit-tap-highlight-color: transparent;
  `,
}
